import BaseService from "./geral/BaseService"
import moment from 'moment'

const base = "Moviment";

export default class MovimentacaoService extends BaseService {
    constructor() {
        super(base);
    }

    listarTodosCampos(membershipUserId) {
        return super.httpGet(`/${base}/ListarCamposExib/${membershipUserId}`)
    }

    listarOperacoes(dataInicial, dataFinal) {
        return super.httpGet(`/${base}/ListarOper/${dataInicial}/${dataFinal}`);
    }

    listarArmadores(membershipUserId) {
        return super.httpGet(`/${base}/listarArmadores/${membershipUserId}`);
    }

    listarClientes(membershipUserId, filtro) {
        const params = filtro ? `?filtro=${filtro}` : ''
        return super.httpGet(`/${base}/ListarClientes/${membershipUserId}${params}`);
    }

    listarGurposClientes() {
        return super.httpGet(`/${base}/ListarGruposClientes/`);
    }

    listarFiltros(membershipUserId) {
        return super.httpGet(`/${base}/ListarFiltros/${membershipUserId}`)
    }

    listaTiposMov() {
        return super.httpGet(`/${base}/ListarTiposMoviment/`)
    }

    listarStatus() {
        return super.httpGet(`/${base}/ListarStatusContainer/`)
    }

    listarTipoCntr() {
        return super.httpGet(`/${base}/ListarTipoContainer/`)
    }

    listarTamCntr() {
        return super.httpGet(`/${base}/ListarTamanhoContainer/`)
    }

    listarCategorias() {
        return super.httpGet(`/${base}/ListarCategorias/`)
    }

    pesquisar(filtros) {
        return super.httpPost(`/${base}/Pesquisar/1/1000`, filtros);
    }


    salvarFiltro(filtro) {
        filtro.DataUltimaModificacao = moment().format()
        return super.httpPost(`/${base}/SalvarFiltro`, filtro)
    }

    obrigatorioMovimentacao = ["Container", "ArmId"];

    novoValor = {
        valor: "0",
        nome: "Padrão",
        descricao: "Desc",
        dadosTabela: this.obrigatorioMovimentacao
    }

    novoFiltro = {
        Id: 0,
        ApplicationId: 1,
        TaskId: 1,
        OperationId: 1,
        MembershipuserId: 0,
        TipoObjeto: "FILTRO",
        NomeObjeto: "",
        DescricaoObjeto: "Filtro Movimentacao",
        ValorObjeto: "this.novoValor",
        DataUltimaModificacao: ""
    }
}


// WEBPACK FOOTER //
// ./src/services/MovimentacaoService.js